import React from 'react';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useUser } from '@auth0/nextjs-auth0';
import { getUserRole } from '../../../utils/helpers/userHelper';
import { UserInfo } from '../../../utils/interfaces';

export default function Home() {
  //get query parameters from URL
  const router = useRouter();
  const { eventname, eventid } = router.query; //rename?
  const eventNameDecoded = decodeURIComponent(eventname as string);

  //check if user is logged in
  const { user } = useUser();
  const userRole = getUserRole(user);

  useEffect(() => {
    //user is already logged in, redirect to form
    if (router.isReady && (userRole === 'editor' || userRole === 'admin')) {
      router.push(`/event/eventForm/${eventid}?logintype=user`);
    }
  }, [router, userRole, eventid]);

  async function logInButton() {
    router.push(
      `/api/auth/login?redirect-url=/event/eventForm/${eventid}&logintype=login`
    );
  }

  async function createAccountButton() {
    router.push(`/event/createAccount?eventId=${eventid}`);
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#40978F' }}
    >
      <div className="bg-white rounded-3xl shadow-lg flex flex-col items-center px-10 py-12 w-full max-w-md">
        <img
          src="/confirmedTMLogo.svg"
          alt="Confirmed Logo"
          className="h-16 mb-6"
        />
        {/* Headline and Description */}
        <div className="mb-8 flex flex-col items-center">
          <h1 className="text-2xl font-bold text-center mb-4">
            Ready to network at{' '}
            <span className="text-[#2CA6A4]">{eventNameDecoded}</span>? Setup
            takes just a minute.
          </h1>
          <p className="text-center text-gray-600 mb-4 text-lg">
            Simply log in to Confirmed (to prefill your details for our event)
            or sign up free
            <br /> — it only takes a moment to get started.
          </p>
        </div>
        {/* Auth0 Login/Signup Box Placeholder */}
        <div className="w-full space-y-4">
          <button
            onClick={createAccountButton}
            className="w-full bg-[#2CA6A4] text-white py-4 rounded-xl text-lg font-semibold hover:bg-[#238b8a] transition-all duration-200 transform hover:scale-[1.02] shadow-md hover:shadow-lg"
          >
            I’m new here —&gt; (Create Account)
          </button>

          <button
            onClick={logInButton}
            className="w-full bg-white text-[#2CA6A4] py-4 rounded-xl text-lg font-semibold border-2 border-[#2CA6A4] hover:bg-[#2CA6A4] hover:text-white transition-all duration-200 transform hover:scale-[1.02] shadow-md hover:shadow-lg"
          >
            Returning Confirmed user —&gt; Login
          </button>
        </div>
        <div className="mt-5">
          <a
            href="/Help_File_-_Using_Confirmed_Meet-&-Greet_at_a_Networking_Event.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <h2 className="text-lg text-blue-600 font-semibold hover:underline mb-4">
              Tips/Help
            </h2>
          </a>
        </div>
      </div>
    </div>
  );
}
